export class ActionConstants {
	public static readonly FETCH: string = 'FETCH_';

	public static readonly ADD_ONE: string = 'ADD_ONE_';
	public static readonly ADD_MANY: string = 'ADD_MANY_';
	public static readonly ADD_ALL: string = 'ADD_ALL_';

	public static readonly REMOVE_ONE: string = 'REMOVE_ONE_';
	public static readonly REMOVE_MANY: string = 'REMOVE_MANY_';
	public static readonly REMOVE_ALL: string = 'REMOVE_ALL_';

	public static readonly UPDATE_ONE: string = 'UPDATE_ONE_';
	public static readonly UPDATE_MANY: string = 'UPDATE_MANY_';

	public static readonly UPSERT_ONE: string = 'UPSERT_ONE_';
	public static readonly UPSERT_MANY: string = 'UPSERT_MANY_';

	public static readonly LOAD_ONE: string = 'LOAD_ONE_';

	public static readonly NO_ACTION: string = 'NO_ACTION_';

	public static readonly REDUX_MODIFY: string = 'REDUX_MODIFY_';
	public static readonly REDUX_DELETE: string = 'REDUX_DELETE_';
}

export class PortfolioEditorActionConstants {

	// Updates an existing entry in the map - to be used when making updates from components
	public static readonly UPDATE_MAP: string = 'UPDATE_MAP_';

	// To reset the map and start from having an empty root node
	public static readonly RESET_MAP: string = 'RESET_MAP_';
}
